// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/EuclidRegular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Humans-Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

body {
  font-family: "Noto Sans" !important;
}

.input {
  font-family: "Noto Sans" !important;
}

#password:-webkit-autofill,
#email:-webkit-autofill,
#password:-webkit-autofill:hover,
#email:-webkit-autofill:hover,
#password:-webkit-autofill:focus,
#email:-webkit-autofill:focus,
#password:-webkit-autofill:active,
#email:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #152d73 inset !important;
  -webkit-text-fill-color: white !important;
}

.react-flow__attribution a {
  display: none;
}

#eventInput:focus-visible {
  outline: 1px solid #152d73;
}

#scrollableDiv1::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
#scrollableDiv1 {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.infinite-scroll-component__outerdiv {
  width: 100%;
}
/* .react-flow__edge-path {
    stroke: #f7c544 !important;
    strokeWidth: 2 !important;
  }
  .react-flow__edge.selected {
    stroke: rgb(247, 150, 10) !important;
    strokeWidth: 2 !important;
  } */
.edgebutton {
  width: 25px;
  height: 25px;
  background: rgb(244, 67, 54, 0.8);
  border: 1px solid rgb(244, 67, 54, 1);
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
  line-height: 1;
}

.edgebutton:hover {
  background: rgb(244, 67, 54, 1);
}

.react-flow__node-custom {
  font-size: 10px;
  width: 180px;
  background: #f5f5f6;
  color: #222;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 15%), 0 2px 4px -1px rgb(0 0 0 / 8%);
  border-radius: 2px;
}

.react-flow__node-custom .react-flow__handle {
  top: 24px;
  right: -15px;
  width: 6px;
  height: 10px;
  border-radius: 2px;
  background-color: #778899;
}

.react-flow__node.circle {
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
}

.react-flow__node.annotation {
  border-radius: 0;
  text-align: left;
  background: white;
  border: none;
  line-height: 1.4;
  width: 225px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 15%), 0 2px 4px -1px rgb(0 0 0 / 8%);
}

.react-flow__node.annotation .react-flow__handle {
  display: none;
}

.react-flow__controls-button {
  width: 18px !important;
  height: 18px !important;
}

.react-flow__controls-button svg {
  max-height: 14px !important;
  max-width: 14px !important;
}

.custom-node__header {
  padding: 8px 10px;
  border-bottom: 1px solid #e2e8f0;
}

.custom-node__body {
  padding: 10px;
}

.custom-node__select {
  position: relative;
  margin-bottom: 10px;
}

.custom-node__select select {
  width: 100%;
  margin-top: 5px;
  font-size: 10px;
}

#password:-webkit-autofill,
#email:-webkit-autofill,
#password:-webkit-autofill:hover,
#email:-webkit-autofill:hover,
#password:-webkit-autofill:focus,
#email:-webkit-autofill:focus,
#password:-webkit-autofill:active,
#email:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  -webkit-text-fill-color: black !important;
  font-family: "Noto Sans" !important;
}

input:-webkit-autofill::first-line {
  font-family: "Noto Sans" !important;
}
.chakra-checkbox__control {
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;;;;;;EAQE,uDAAuD;EACvD,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,WAAW;AACb;AACA;;;;;;;KAOK;AACL;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,2EAA2E;EAC3E,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,2EAA2E;AAC7E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;;;;;;;;EAQE,qDAAqD;EACrD,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,2BAA2B;AAC7B","sourcesContent":["@font-face {\n  font-family: \"Humans-Sans\";\n  src: url(\"./assets/fonts/EuclidRegular.ttf\");\n}\n\nbody {\n  font-family: \"Noto Sans\" !important;\n}\n\n.input {\n  font-family: \"Noto Sans\" !important;\n}\n\n#password:-webkit-autofill,\n#email:-webkit-autofill,\n#password:-webkit-autofill:hover,\n#email:-webkit-autofill:hover,\n#password:-webkit-autofill:focus,\n#email:-webkit-autofill:focus,\n#password:-webkit-autofill:active,\n#email:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px #152d73 inset !important;\n  -webkit-text-fill-color: white !important;\n}\n\n.react-flow__attribution a {\n  display: none;\n}\n\n#eventInput:focus-visible {\n  outline: 1px solid #152d73;\n}\n\n#scrollableDiv1::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n#scrollableDiv1 {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n.infinite-scroll-component__outerdiv {\n  width: 100%;\n}\n/* .react-flow__edge-path {\n    stroke: #f7c544 !important;\n    strokeWidth: 2 !important;\n  }\n  .react-flow__edge.selected {\n    stroke: rgb(247, 150, 10) !important;\n    strokeWidth: 2 !important;\n  } */\n.edgebutton {\n  width: 25px;\n  height: 25px;\n  background: rgb(244, 67, 54, 0.8);\n  border: 1px solid rgb(244, 67, 54, 1);\n  text-align: center;\n  cursor: pointer;\n  border-radius: 4px;\n  line-height: 1;\n}\n\n.edgebutton:hover {\n  background: rgb(244, 67, 54, 1);\n}\n\n.react-flow__node-custom {\n  font-size: 10px;\n  width: 180px;\n  background: #f5f5f6;\n  color: #222;\n  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 15%), 0 2px 4px -1px rgb(0 0 0 / 8%);\n  border-radius: 2px;\n}\n\n.react-flow__node-custom .react-flow__handle {\n  top: 24px;\n  right: -15px;\n  width: 6px;\n  height: 10px;\n  border-radius: 2px;\n  background-color: #778899;\n}\n\n.react-flow__node.circle {\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 700;\n}\n\n.react-flow__node.annotation {\n  border-radius: 0;\n  text-align: left;\n  background: white;\n  border: none;\n  line-height: 1.4;\n  width: 225px;\n  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 15%), 0 2px 4px -1px rgb(0 0 0 / 8%);\n}\n\n.react-flow__node.annotation .react-flow__handle {\n  display: none;\n}\n\n.react-flow__controls-button {\n  width: 18px !important;\n  height: 18px !important;\n}\n\n.react-flow__controls-button svg {\n  max-height: 14px !important;\n  max-width: 14px !important;\n}\n\n.custom-node__header {\n  padding: 8px 10px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.custom-node__body {\n  padding: 10px;\n}\n\n.custom-node__select {\n  position: relative;\n  margin-bottom: 10px;\n}\n\n.custom-node__select select {\n  width: 100%;\n  margin-top: 5px;\n  font-size: 10px;\n}\n\n#password:-webkit-autofill,\n#email:-webkit-autofill,\n#password:-webkit-autofill:hover,\n#email:-webkit-autofill:hover,\n#password:-webkit-autofill:focus,\n#email:-webkit-autofill:focus,\n#password:-webkit-autofill:active,\n#email:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px white inset !important;\n  -webkit-text-fill-color: black !important;\n  font-family: \"Noto Sans\" !important;\n}\n\ninput:-webkit-autofill::first-line {\n  font-family: \"Noto Sans\" !important;\n}\n.chakra-checkbox__control {\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
